export default function is_array(obj) {
    return obj instanceof Array
}
